import {FeatureDiffController} from '../features/components/FeatureDiffController'
import {Feature} from '../features'
import {connect} from '../redux/utils'
import {selectFeatures} from '../features/selectors'
import {bindActionCreators} from 'redux'
import {handleFeatureChange} from './actions'

class TimeTrackPageFeatureDiffController extends FeatureDiffController {
    constructor({
        handleFeatureChange = () => {},
    }) {
        super({
            handledFeatures: [Feature.TWS],
            onFeaturesChanged: handleFeatureChange,
        })
    }
}

export default connect(
    state => ({
        features: selectFeatures(state),
    }),
    dispatch => ({
        handleFeatureChange: bindActionCreators(handleFeatureChange, dispatch),
    })
)(TimeTrackPageFeatureDiffController)



// WEBPACK FOOTER //
// ./web/js/user/TimeTrackPageFeatureDiffController.js